/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputAdornment, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { LanguageContext } from '../../../../../../../../../libs/Context';
import useDebounce from '../../../../../../../../../components/Hooks/useDebounce';
import useInterSectionObserver from '../../../../../../../../../libs/CustomHooks/useIntersectionObserver';
import { catchErr } from '../../../../../../../../../libs/HelperContent';
import { toast } from 'react-toastify';
import AddHostsBody from './AddHostBody';
import { getConfigDetails, getOtherEmployees, updateAcces } from '../../../../../../../../actions/meeting_actions';
import Loading from '../../../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { useSelector } from 'react-redux';
import NoData from '../../../../../../../../../components/Common/NoData';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

interface HostTableState {
    loading: boolean;
    empCount: number;
    addEmpData: any;
    searchVal: string;
}
const AddEmployeeHeader = (props) =>
{
	const { open, onClose, expand, alrdyAddedUsersref, configKey, configType,
		setCallApi, from, handleNext, feedType, updateOccasionEmp, updateTagPeople } = props;
	const getListApi = from === 'newsFeed' ? getOtherEmployees : getConfigDetails;
	const { language } = useContext(LanguageContext);
	const [ initialState, setInitialState ] = useState<HostTableState>({
		loading    : false,
		empCount   : 0,
		addEmpData : [],
		searchVal  : ''
	});
	const { empCount, addEmpData, searchVal, loading } = initialState;
	const debouncedSearch = useDebounce(searchVal, 500);
	const [ page, setPage ] = useState<number>(0);
	const loaderRef = useRef<any>();
	const lastEleRef = useRef<HTMLDivElement | null>(null);
	const userData = useSelector((state:any) => state?.mysession?.session);

	const userSlctd = Array.isArray(alrdyAddedUsersref?.current)
		? alrdyAddedUsersref.current.map((users) =>
			([ 'editOccasion', 'tagPeople' ].includes(feedType)
				? { userId: users?.userId, name: users?.name }
				: { userId: users?.userId })
		)
		: [];

	const [ slctdUsers, setSlctdUsers ] = useState<any>(alrdyAddedUsersref?.current?.length > 0 ? userSlctd : []);
	const [ isSkiping, setSkip ] = useState(false);
	const LoadMoreList = useInterSectionObserver({
		lastEleRef, loaderRef, count : initialState?.empCount, data : initialState?.addEmpData, setPage
	});

	const getHostCount = async (query:any) =>
	{
		try
		{
			query.count = true;
			const res = await getListApi(query);

			if (res?.status)
			{
				setInitialState((prev) => ({ ...prev, empCount: res?.count }));
			}
		}
		catch (err)
		{
			console.error('Error fetching host count:', err);
			setInitialState((prev) => ({ ...prev, loading: false }));
		}
	};

	const getHostsList = async () =>
	{
		setInitialState((prev) => ({ ...prev, loading: (page === 0 && searchVal === '') }));
		try
		{
			const query:any = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role,
				skip    : page,
				limit   : 12,
				status  : 'approve'
			};

			if (configKey === 'meetingConfiguration') query.userRole = 'admin,superAdmin';
			if (searchVal !== '') query.search = searchVal;

			const res = await getListApi(query);

			if (res?.status)
			{
				const combinedData = page === 0 ? res?.data : [ ...addEmpData, ...res?.data ];
				const count = res?.data?.length >= 12 ? getHostCount(query) : res?.data?.length;

				setInitialState((prev) => ({ ...prev, addEmpData: combinedData, empCount: count, loading: false }));

				loaderRef.current = false;
			}
		}
		catch (err)
		{
			console.log('---------------', err);
			setInitialState((prev) => ({ ...prev, loading: false }));
			loaderRef.current = false;
			// catchErr(err);
			toast.error(language.unableToLoadEmployeeList);
		}
	};

	const handleCheckBox = (admin) =>
	{
		if (admin === 'All')
		{
			const updateEmpl = addEmpData?.map((admi: any) => ({
				userId                                     : admi?.userId,
				[from === 'newsFeed' ? 'name' : 'empRole'] : admi[from === 'newsFeed' ? 'name' : 'empRole']
			})) || [];

			if (from === 'newsFeed')
			{
				setSlctdUsers((prev) =>
				{
					if (prev.length === addEmpData?.length)
					{
						return []; // Unselect all
					}

					return updateEmpl; // Select all
				});
			}
			else
			{
				setSlctdUsers(slctdUsers?.length === addEmpData?.length
					? (alrdyAddedUsersref?.current?.length > 0 ? userSlctd : [])
					: updateEmpl
				);
			}
		}
		else
		{
			const updatedEmp = slctdUsers?.some((emply) => emply?.userId === admin?.userId)
				? slctdUsers?.filter((emp) => emp?.userId !== admin?.userId)
				: [ ...slctdUsers, {
					userId                                     : admin?.userId,
					[from === 'newsFeed' ? 'name' : 'empRole'] : admin[from === 'newsFeed' ? 'name' : 'empRole']
				} ];

			setSlctdUsers(updatedEmp);
		}
	};

	const alreadyAddedUserIds = new Set(Array.isArray(alrdyAddedUsersref?.current) ? alrdyAddedUsersref.current.map((user) => user?.userId) : []);
	const newUserIds = slctdUsers?.filter((user) => !alreadyAddedUserIds.has(user?.userId)).map((user) => user?.userId);

	const handleAddEmp = async () =>
	{
		setInitialState((prev) => ({ ...prev, loading: page === 0 }));
		try
		{
			const body:any = {
				userIds    : newUserIds || '',
				actionType : configKey,
				module     : configType

			};

			if (configKey === 'hostManagement')
			{
				body.hostAction = 'add';
			}
			if (configKey === 'meetingConfiguration')
			{
				body.configurationAction = 'add';
			}
			const res = await updateAcces(body);

			if (res?.status)
			{
				setCallApi(res?.status);
				toast.success(language?.empAddedSuccess, {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});
			}
			onClose();
		}
		catch (err)
		{
			catchErr(err);
			console.log(err);
			onClose();
		}
	};

	const handleAddBtn = () =>
	{
		if (from === 'newsFeed' && !isSkiping)
		{
		  if (feedType === 'editOccasion') updateOccasionEmp({ employees: slctdUsers }, 0);
		  else if (feedType === 'tagPeople')updateTagPeople({ employees: slctdUsers }, 0);
		  else handleNext({ employees: slctdUsers }, 2);
		}
		else
		{
		  handleAddEmp();
		}
	};

	useEffect(() =>
	{
		LoadMoreList();
	}, [ lastEleRef, empCount, addEmpData ]);

	useEffect(() =>
	{
		if (expand || from === 'newsFeed')
		{
			getHostsList();
		}
	}, [ expand, page, debouncedSearch ]);

	const headers = [
		// { label: <Checkbox checked={addEmpData?.length === slctdUsers?.length} onChange={() => handleCheckBox('All')}/>, key: 'select' },
		{ label: language?.name, key: 'nameId' },
		// { label: language?.email, key: 'email' },
		// { label: language?.role, key: 'role' },
		{ label: language?.designation, key: 'designation' }

	];

	console.log(loading);

	const btnDisabled = Array.isArray(alrdyAddedUsersref?.current) && alrdyAddedUsersref.current.length === slctdUsers?.length && alrdyAddedUsersref.current.filter((user:any) => !slctdUsers?.some((slctUser:any) => slctUser?.userId === user?.userId)).length === 0;

	useEffect(() =>
	{
		if (isSkiping)
		{
			if (feedType === 'editOccasion')
			{
				updateOccasionEmp(
					alrdyAddedUsersref?.current?.length > 0
						? { employees: userSlctd }
						: [],
					0
				);
			}
			else if (feedType === 'tagPeople')
			{
				updateTagPeople(
					alrdyAddedUsersref?.current?.length > 0
						? { employees: userSlctd }
						: [],
					0
				);
			}
			else
			{
				handleNext({ employees: [] }, 2);
			}
			setSkip(false);
		}
	}, [ isSkiping ]);

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='sm'
		>
			{loading && <Loading/>}
			<DialogTitle id='alert-dialog-title'>
				<Grid container justifyContent={'space-between'} alignItems={'center'}>
					<Grid item flexDirection={'row'} display={'flex'} alignItems={'center'}>
						{from === 'newsFeed' && <Box p='var(--pixel8)' display={'flex'} alignItems={'center'}>
							<ArrowBackOutlinedIcon onClick={onClose} className='pointer'/>
						</Box>
						}
						<Typography variant='h6' fontWeight='var(--font500)' color={'var(--screenShare)'}>
							{props.title || language?.selectEmployee}
						</Typography>
					</Grid>
					<Grid item onClick={onClose} className='pointer'>
						<RxCross2/>
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent>
				<Grid container flexDirection={'column'} spacing={1}>
					<Grid item>
						<Stack direction={'row'} justifyContent={'space-between'}>
							<Grid item>
								<TextField
									variant='outlined'
									type='search'
									size='small'
									sx={{ width: 300 }}
									placeholder={language?.search}
									value={searchVal}
									onChange={(e) => { setInitialState((prev) => ({ ...prev, searchVal: e.target.value.replace(/^\s+/, '') })); setPage(0); }}
									disabled={addEmpData?.length === 0 && searchVal === ''}
									InputProps={{
										startAdornment : (
											<InputAdornment position='start'>
												<SearchIcon />
											</InputAdornment>
										)
									}}
									id='search'
								/>
							</Grid>
							<Grid item>
								{from !== 'newsFeed' &&
								<Button onClick={handleAddBtn} variant='contained' sx={{ color: 'var(--whiteColor)' }}
									disabled={btnDisabled}
									startIcon={<AddIcon/>}
								>
									{language?.add}
								</Button>}
							</Grid>
						</Stack>
					</Grid>
					<Grid item>
						<div style={{ maxHeight: '600px', overflowY: 'auto' }} >
							<TableContainer>
								<Table stickyHeader aria-label='sticky table'>
									<TableHead>
										<TableRow>
											<TableCell sx={{ width: '0%' }}>
												{!debouncedSearch && addEmpData?.length > 0 && <Checkbox checked={addEmpData?.length === slctdUsers?.length} onChange={() => handleCheckBox('All')}/>}
											</TableCell>
											{addEmpData && addEmpData?.length > 0 && headers?.map(({ label, key }, index) => (
												<TableCell key={key} sx={{ minWidth: index === headers.length - 1 ? '150px' : '', padding: '6px' }}>
													{typeof label === 'string' ? <Typography>{label}</Typography> : label}
												</TableCell>
											))}
										</TableRow>
									</TableHead>
									<TableBody>
										{/* set employee list...to populate */}
										{addEmpData && addEmpData?.length > 0 && addEmpData?.map((empData, index) => (
											<>
												<AddHostsBody
													empData={empData}
													handleCheckBox={handleCheckBox}
													slctdUsers={slctdUsers}
													alrdyAddedUsersref={alrdyAddedUsersref}
													feedType={feedType}
												/>
												{index === (addEmpData?.length - 2) && <span ref={lastEleRef}/>}
											</>
										))}
									</TableBody>
								</Table>
							</TableContainer>
							{
								!loading && addEmpData?.length === 0 &&
								<div className='flexCol pdngXS fullHeight justifyCntr'>
									<NoData noDataHead={language?.nodataFound} color='lightTxt'
										src1={'/images/Bpsnodata.svg'}
									/>
								</div>
							}
						</div>
					</Grid>
				</Grid>
			</DialogContent>
			{from === 'newsFeed' && <DialogActions>
				<Stack direction='row' p='var(--pixel16)' alignItems={'center'} display={'flex'} spacing={1.5}>
					{ feedType !== 'editOccasion' &&
					<Button
						disableElevation
						disableRipple
						variant='outlined'
						onClick={() => { setSkip(true); }}
					>
						{language?.skip}
					</Button>}
					<Button
						disableElevation
						disableRipple
						onClick={handleAddBtn}
						variant='contained'
						// className='whiteTxt'
						className={(userSlctd.length === 0 && slctdUsers?.length === 0) ? 'buttonBg disableMode' : 'buttonBg'}
						disabled={(from === 'newsFeed'
							? (userSlctd.length === 0 && slctdUsers?.length === 0)
							: btnDisabled) || (
							JSON.stringify(userSlctd) === JSON.stringify(slctdUsers))}
					>
						{feedType === 'editOccasion' ? language?.select : language?.next}
					</Button>
				</Stack>
			</DialogActions>}
		</Dialog>
	);
};

export default AddEmployeeHeader;
